const people = [
    {
      name: 'Janab Imthiaz Pasha ',
      role: 'Chairman',
      imageUrl:
        'https://thenewcollege.edu.in/images/chairman.jpg',
    },
    {
      name: 'Janab. Elias Sait',
      role: 'Secretary & Correspondent',
      imageUrl:
        'https://thenewcollege.edu.in/images/secretary.jpg',
    },
    {
      name: 'Mr. S.M.A. Mohammed Saleem',
      role: 'Hony. Treasurer',
      imageUrl:
        'https://thenewcollege.edu.in/images/treasurer.jpg',
    },
    {
      name: 'Dr. M. Asrar Sheriff',
      role: 'Pricipal',
      imageUrl:
        'https://thenewcollege.edu.in/images/principal.jpg',
    },
    // More people...
  ]
  
  export default function Testi() {
    return (
      <div className="bg-white py-24 sm:py-32 rounded-lg shadow-lg mb-20 mt-20">
        <div className="mx-auto grid max-w-7xl gap-20 px-6 lg:px-8 xl:grid-cols-3">
          <div className="max-w-xl">
            <h2 className="text-3xl font-semibold tracking-tight text-pretty text-gray-900 sm:text-4xl">
            The New College Legacy Beyond Curriculum
            </h2>
            <p className="mt-6 text-lg/8 text-gray-600">
            The New College legacy extends far beyond traditional academic curriculum, embodying a spirit of innovation, inclusivity, and interdisciplinary exploration. Known for its progressive approach to education, New College fosters intellectual curiosity, critical thinking, and a deep commitment to social impact.
            </p>
          </div>
          <ul role="list" className="grid gap-x-8 gap-y-12 sm:grid-cols-2 sm:gap-y-16 xl:col-span-2">
            {people.map((person) => (
              <li key={person.name}>
                <div className="flex items-center gap-x-6">
                  <img alt="" src={person.imageUrl} className="size-32 rounded-full" style={{objectFit:"cover"}} />
                  <div>
                    <h3 className="text-xl font-semibold tracking-tight text-gray-900">{person.name}</h3>
                    <p className="text-sm/6 font-semibold text-indigo-600">{person.role}</p>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    )
  }
  